import React from "react";
import styled from "styled-components";
import * as PropTypes from "prop-types";
import {Heading1} from "../style/itf-styled-components";

const Container = styled.div`
  white-space: nowrap;
  
  @media (max-width: 768px) {
    white-space: normal;
  }
`;
const ColumnHeading = styled(Heading1)`
  padding-left: 25px;
  padding-right: 25px;
  color: ${props => props.theme.text};
  
  @media (max-width: 768px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
/* eslint-disable no-unused-vars */
const PlaceholderHeading = styled(ColumnHeading)`
  color: transparent;

  ::before {
    content: '\\00a0';
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;
/* eslint-enable no-unused-vars */

const Content = styled.div`
  white-space: normal;
`;

const Column = ({className, heading, children}) => (
  <Container className={className}>
    {!!heading && <ColumnHeading>{heading}</ColumnHeading>}
    <Content>{children}</Content>
  </Container>
);

Column.defaultProps = {
  theme: "light"
};

Column.propTypes = {
  theme: PropTypes.oneOf(["light", "dark", "pitchBlack"]),
  heading: PropTypes.string
};

export default Column;